/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const NAME = feature.getSettingValue('NAME');
    const CODE = feature.getSettingValue('CODE');
    const paramsCode = [];
    let setupCode = '';
    let resultCode = '';

    const inputs = feature.getSettingValue('INPUTS');
    const outputs = feature.getSettingValue('OUTPUTS');
    for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        const params = input.getSettingValue('PARAMS');

        if (i === 0) {
            for (let j = 0; j < params.length; j++) {
                const param = params[j];
                paramsCode.push(`${param.getSettingValue('NAME')} as ${param.getSettingValue('DATATYPE')}`);
            }
        }
        const links = project.getNodeLinks(feature, input.getSettingValue('PORTID'));
        for (let j = 0; j < links.length; j++) {
            const args = [];
            const link = links[j];
            for (let j = 0; j < params.length; j++) {
                const param = params[j];
                const arg = project.getNodeParameter(link, param.getSettingValue('NAME'));
                args.push(arg);
            }
            blocks.push({
                location: link.getSourceId(),
                id: link.getID(),
                blockType: BlockType.CODE,
                template: `
    ${NAME}(${args.join(',')})`,
            });
        }
    }

    for (let i = 0; i < outputs.length; i++) {
        const output = outputs[i];
        const params = output.getSettingValue('PARAMS');

        if (i === 0) {
            for (let j = 0; j < params.length; j++) {
                const param = params[j];
                setupCode += `dim ${param.getSettingValue('NAME')} as ${param.getSettingValue('DATATYPE')}\n`;
            }
        }
        const links = project.getNodeLinks(feature, output.getSettingValue('PORTID'));
        for (let j = 0; j < links.length; j++) {
            const link = links[j];
            if (i === 0) {
                resultCode = `'****${link.getSourceId()}****'`;
            }
        }
    }

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        id: `declare${feature.getID()}`,
        template: `
declare sub ${NAME}(${paramsCode.join(',')})`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: `sub${feature.getID()}`,
        template: `
sub ${NAME}(${paramsCode.join(',')})
    ${setupCode}
    ${CODE}
    ${resultCode}
end sub
    `,
    });

    return blocks;
};
